<template>
  <div>
    <li class="padding-horizontal">
      <div class="item-title item-label">
        {{ config.nameInput }}
      </div>
    </li>
    <f7-list-item
      :ref="config.ref"
      :title="config.nameInput"
      smart-select
      required
      validate
      :value="elementSelected"
      :smart-select-params="{
        closeOnSelect: true,
        searchbar: true,
        virtualList: true,
      }"
    >
      <select
        :name="config.ref"

        @change="elementSelected = $event.target.value"
      >
        <option
          selected
          value=""
        />
        <option
          v-for="(f) in listElement"
          :key="f.id"
          :value="f[config.returnValue]"
        >
          {{ f[config.showValue] }}
        </option>
      </select>
    </f7-list-item>
  </div>
</template>

<script>
import MasterDataService from '@/js/services/contracts/MasterData';
import FarmerService from '@/js/services/contracts/Farmers';

export default {
  name: 'UCSmartSelectParamsReport',
  props: {
    varieties: { type: Array, default: null },
    config: { type: Object, default: null },
    param: { type: Object, default: null },
  },

  emits: [
    'data-selected',
    'param-changed',
  ],

  data() {
    return {
      elementSelected: null,
      listElement: [],
      paramsChanged: null,
    };
  },

  watch: {
    elementSelected() {
      this.$emit('data-selected', this.elementSelected);
      this.paramsChanged = this.param;
      this.paramsChanged.Valor = this.elementSelected;
      this.$emit('param-changed', this.paramsChanged);
    },
  },

  mounted() {
    if (this.varieties) {
      this.listElement = this.varieties;
    } else {
      this.loadMasterData();
    }
  },
  methods: {
    async loadMasterData() {
      let data = [];
      if (!this.config) {
        return;
      }

      switch (this.config.type) {
        case 'masterData':
          data = await MasterDataService[this.config.method]();
          break;
        case 'farmer':
          data = await FarmerService.getFarmersFullInfo();
          break;
        default:
          data = [];
          break;
      }
      this.listElement = data;
    },
  },
};
</script>
